import React from 'react';
import {InputRadiobox} from '../'

export function KitchenwareSetting(props) {
  const item=props.item
  return (
    <li className='recipe__kitchenware_item'>
      <InputRadiobox item={item} onChange={props.handleChange}/>
      <p className={`recipe__kitchenware_icon gg-${item.nameEn} l-size `} ></p>
    </li>
  )        
}
